// @flow
import { useNavigation } from '@react-navigation/native';
import React, { useContext } from 'react';
import {
    Pressable, useWindowDimensions, View,
} from 'react-native';
import { useIntl } from 'react-intl';
import { APIContext, getUser } from 'speed-js-react';
import { useDispatch, useSelector } from 'react-redux';
import { setPermissions, removeUser } from 'speed-js-react/src/redux/auth/actions';
import Logo from 'src/assets/logo.png';
import { navigateWithoutHistory } from 'src/navigation/Stack';
import { HOME_SCREEN } from 'src/navigation/constants';
import Text from '../CustomText/CustomText';
import styles from './HeaderStyles';
import AccountProfileIcon from '../../Icons/AccountProfileIcon';

const wrapperStyles = {
    Desktop: styles.external_wrapper,
    Tablet: [styles.external_wrapper, styles.externalWrapperTablet],
    Phone: [styles.external_wrapper, styles.externalWrapperMobile],
};

const MyHeader = () => {
    const user = useSelector(getUser);
    const { apiClient } = useContext(APIContext);
    const dispatch = useDispatch();
    const navigation = useNavigation();
    const handleLogoutClick = () => {
        apiClient.deauthorize().then(() => {
            dispatch(setPermissions({}));
            dispatch(removeUser());
            window.location.href = '/';
        });
    };
    const { formatMessage } = useIntl();
    const { width } = useWindowDimensions();

    let screenSize = 'Desktop';
    if (width > 575 && width < 960) {
        screenSize = 'Tablet';
    } else if (width <= 575) {
        screenSize = 'Phone';
    }

    return (
        <View>
            <View style={wrapperStyles[screenSize]}>
                <Pressable
                    onPress={() => {
                        if (user) {
                            navigateWithoutHistory(navigation, HOME_SCREEN);
                        } else {
                            window.location.href = '/';
                        }
                    }}
                    style={styles[`logo${screenSize}`]}
                >
                    <img src={Logo} style={styles[`logo${screenSize}`].width} alt="coool.tv" />
                </Pressable>
                <View style={styles.logout_button_wrapper}>
                    {user && (
                        <>
                            <AccountProfileIcon />
                            {width > 600 && (
                                <View style={styles.username_wrapper}>
                                    <Text style={styles.username_text}>
                                        {user.username}
                                    </Text>
                                </View>
                            )}
                            <Pressable onPress={handleLogoutClick}>
                                <Text style={styles.logout_button}>
                                    {formatMessage({ id: 'logout', defaultMessage: 'Logout' })}
                                </Text>
                            </Pressable>
                        </>
                    )}
                </View>
            </View>
        </View>
    );
};

export default MyHeader;
